import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { formatDate } from '../utils/formatDate';
import { formatCategory } from '../utils/formatCategory';

interface MinimalArticleCardProps {
  id: string;
  slug?: string;
  title: string;
  excerpt: string;
  publishedAt: string;
  category: string;
  readingTime?: number;
  author?: {
    name: string;
    avatar?: string;
  };
}

export function MinimalArticleCard({ 
  id, 
  slug,
  title, 
  excerpt, 
  publishedAt,
  category,
  readingTime = 5
}: MinimalArticleCardProps) {
  return (
    <motion.article 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="group cursor-pointer"
    >
      <Link to={`/blog/${slug || id}`}>
        <time className="text-sm text-gray-500 dark:text-gray-400">
          {formatDate(publishedAt)}
        </time>
        <h3 className="mt-3 text-2xl font-light text-gray-900 dark:text-white group-hover:text-orange-600 dark:group-hover:text-orange-400 transition-colors duration-300 line-clamp-2">
          {title}
        </h3>
        <p className="mt-4 text-gray-600 dark:text-gray-300 leading-relaxed line-clamp-3">
          {excerpt}
        </p>
        <div className="mt-4 flex items-center gap-4">
          <span className="text-sm text-gray-500 dark:text-gray-400">
            {readingTime} min read
          </span>
          <span className="text-gray-300 dark:text-gray-600">•</span>
          <span className="text-sm text-gray-500 dark:text-gray-400">
            {formatCategory(category)}
          </span>
        </div>
      </Link>
    </motion.article>
  );
}
